import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'tn-empty-page',
  templateUrl: './empty-page.component.html',
  styleUrls: ['./empty-page.component.scss']
})
export class EmptyPageComponent implements OnInit {
  
  @Input() msgKey: string = null;

  constructor() { }

  ngOnInit() {
  }

}
